import { render, staticRenderFns } from "./XhsResources.vue?vue&type=template&id=5015f0e6&scoped=true"
import script from "./XhsResources.vue?vue&type=script&lang=js"
export * from "./XhsResources.vue?vue&type=script&lang=js"
import style0 from "./XhsResources.vue?vue&type=style&index=0&id=5015f0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015f0e6",
  null
  
)

export default component.exports